var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSofort = function SvgSofort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.983 0c-1.264 0-2.492 0-3.593.559-1.1.559-2.071 1.678-2.819 3.915-.162.481-.247.896-.259 1.256-.01.36.052.667.188.934.168.325.441.631.782.889.342.259.75.468 1.19.602l.53.151c.278.08.605.177.811.24.122.037.255.085.375.158.121.071.23.168.298.301a.667.667 0 0 1 .071.29.944.944 0 0 1-.055.335c-.103.304-.259.5-.555.62-.296.119-.731.157-1.392.162h-8.25L0 14h8.831c.831 0 2.35 0 3.81-.622 1.46-.62 2.861-1.861 3.454-4.346.223-.933.154-1.693-.211-2.291-.367-.597-1.03-1.03-1.994-1.307l-.47-.136c-.253-.074-.546-.157-.695-.2a.933.933 0 0 1-.55-.396.78.78 0 0 1-.081-.628.919.919 0 0 1 .458-.551c.232-.129.537-.2.893-.2h5.134c.036-.052.069-.109.105-.16C19.622 1.832 20.757.758 22 0h-8.017Z",
    fill: "#fff"
  })));
};
export default SvgSofort;